import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class ExceptionSolutionService {
  private readonly url = `${environment.url}/exception/fromMessage`;

  constructor(private readonly http: HttpClient,) { }

  retriveExceptionSolutionFromMessage(message: string): Observable<string> {

    return this.http.post<string>(this.url, `{ "exeptionMessage": "${message}" }`);
  }

  async showAlertWithSolution(title: string, message: string = "", doThen: () => any = () => { }, icon: SweetAlertIcon = 'warning', confirmButtonText: string = "Aceptar") {
    const messageIsHtml = message.includes("\"") ? message.replace(/\"/g, ' \\\"') : message;
    const solution = await this.retriveExceptionSolutionFromMessage(messageIsHtml).toPromise().catch(() => "");
    Swal.fire({
      title: `${title}`,
      html: `${message} </br></br> ${solution}`,
      icon: icon,
      confirmButtonText: confirmButtonText,
    }).then(doThen);
  }
}
